export const tenantNavItems = [
  {
    name: 'Dashboard',
    navId: 'dashboard',
    url: '/dashboard',
    icon: 'fal fa-tachometer-alt',
    active: 'active-dashboard',
    activeLinkId: 'dashboard',
    permitted: true,
  },
  {
    name: 'Work Board',
    navId: 'workboard',
    url: '/workboard',
    icon: 'fal fa-columns',
    active: 'active-workboard',
    activeLinkId: 'workboard',
    permitted: true,
  },
  {
    name: 'Calendar',
    navId: 'calendar',
    url: '/calendar',
    icon: 'fal fa-calendar-alt',
    active: 'active-calender',
    activeLinkId: 'calendar',
    permitted: true,
  },
  {
    name: 'Customers',
    navId: 'customers',
    url: '/customers/customers',
    icon: 'fal fa-users',
    active: 'active-lists',
    activeLinkId: 'customers',
    permitted: true,
  },
  {
    name: 'Catalog',
    navId: 'catalog',
    url: '/catalog/labor',
    icon: 'fal fa-book-alt',
    active: 'active-lists',
    activeLinkId: 'catalog',
    permitted: true,
  },
  {
    name: 'Reviews',
    navId: 'reviews',
    url: '/reviews/summary',
    icon: 'fal fa-comments-alt',
    active: 'active-reviews',
    activeLinkId: 'reviews',
    permitted: true,
  },
  {
    name: 'Reports',
    navId: 'reports',
    url: '/reports/sales',
    icon: 'fal fa-signal',
    active: 'active-reports',
    activeLinkId: 'reports',
    permitted: true,
  },
];

export const addMenuList = [
  {
    icon: 'customers.png',
    iconClass: 'fal fa-users',
    type: 'customer',
    title: 'Customer',
    description: 'Add a new customer',
  },
  {
    icon: 'appointments.png',
    iconClass: 'fal fa-calendar-alt',
    type: 'appointment',
    title: 'Appointment',
    description: 'Schedule a new appointment',
  },
  {
    icon: 'estimates.png',
    iconClass: 'fal fa-file-alt',
    type: 'estimate',
    title: 'Estimate & Invoice',
    description: 'Create and send estimates and invoices',
  },
  {
    icon: 'vehicles.png',
    iconClass: 'fal fa-cars',
    type: 'vehicle',
    title: 'Vehicle',
    description: 'Add a vehicle',
  },
  {
    icon: 'parts.png',
    iconClass: 'fal fa-tools',
    type: 'part',
    title: 'Part',
    description: 'Add parts',
  },
  {
    icon: 'payment.png',
    iconClass: 'fal fa-credit-card-front',
    type: 'payment',
    title: 'Payment',
    description: 'Record completed payments',
  },
];

export const serviceLookUpMenu = {
  icon: 'motor-icon-sm.ico',
  iconClass: 'fal fa-car-mechanic',
  type: 'service-lookup',
  title: 'Services lookup',
  description: '',
};

export const mitchell1RepairGuidesMenu = {
  icon: 'M1-1.svg',
  iconClass: 'fal fa-book-open',
  type: 'mitchell1-guide',
  title: 'Repair guides',
  description: 'View-Only repair information in Mitchell1',
};

export const quickTireLookupMenu = {
  icon: 'quick-tire.svg',
  iconClass: 'fal fa-tire',
  type: 'quick-tire-lookup',
  title: 'Quick tire lookup',
  description: 'View available tires'
}
